import React from "react";
import {
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import Carousel from "react-multi-carousel";
import PdfICon from "../../../components/Icons/PdfIcon";
import MapToolBar from "../../../components/MapData/MapToolBar";
import PrismaZoom from "react-prismazoom";
import ImageMapper from "react-img-mapper";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as acts from "../../../redux/validator/actions";
import Label from "../../../components/Label/Label";
import AngleArrowRight from "../../../assets/svg/angle-circle-right-icon.svg";
import AngleArrowLeft from "../../../assets/svg/angle-circle-left-icon.svg";
import "./mapData.scss";
import "./imageViewer.scss";
import "../../../css/utility.scss";
import SearchIcon from "@mui/icons-material/Search";
// import LazyLoad from "react-lazyload";

const CustomLeftArrow = ({ onClick }) => (
  <button
    onClick={() => onClick()}
    className="slick-prev"
    variant="contained"
    size="medium"
    color="primary"
  >
    Prev
  </button>
);
const CustomRightArrow = ({ onClick }) => {
  return (
    <button
      className="slick-next"
      onClick={() => onClick()}
      variant="contained"
      size="medium"
      color="primary"
    >
      Next
    </button>
  );
};

class ImageViewer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      coorData: [],
      selectedFile: {
        tagName: null,
        fileNo: null, // index is considered as file
        pageNo: null,
      },

      zoom: 1,
      prismaZoom: React.createRef(),
      allowZoom: true,
      responsive: {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 5,
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 3,
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 2,
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
        },
      },
      pageRotateAngle: 0,
      imageLoaded: false,
      selectedArea: {},
      data: [],
      originalMapperWidth: 600,
      originalMapperHeight: 768,
      imageMapperWidth: 600,
      imageMapperHeight: 768,
      imageLoadedInDiv: false,
      entireCoorDataFromPageState: [],
      firstCoordinateToAutoScroll: [],
    };
    // Create the child instance using react createRef
    this.child = React.createRef();
    this.checkIsImageLoadable = this.checkIsImageLoadable.bind(this);
  }

  componentDidMount() {
    this.props.acts.clearApiStatus();
  }

  // UNSAFE_componentWillReceiveProps(nextProps) {
  //   // used this to set first pdf selected in initial state  and temp setting some initialn data
  //   if (nextProps?.coorData.length > 0) {
  //     const initialFileIndex = 0;

  //     if (
  //       Object.values(this?.state?.selectedFile).every(
  //         (x) => x === null || x === ""
  //       )
  //     ) {
  //       this.setState({
  //         selectedFile: {
  //           tagName: nextProps?.coorData[0]?.pdfName,
  //           fileNo: 0,
  //           pageNo: 0,
  //         },
  //       });

  //       this.setState({
  //         data: { ...nextProps?.coorData[0]?.pages[0] },
  //         entireCoorDataFromPageState: [...nextProps?.coorData],
  //       }); // initial page setting

  //       // }
  //       this.setState({ imageLoaded: false });
  //       this.checkIsImageLoadable(initialFileIndex, 0); // the second argument is current page number
  //     }

  //     // if (nextProps?.coorData?.length) {
  //     // let sortedCoorData = nextProps?.coorData;

  //     // sortedCoorData.map((fileData, index) => {
  //     //   const sortedPagesData = fileData.pages.sort((a, b) => {
  //     //     return parseInt(a.pageNo) - parseInt(b.pageNo);
  //     //   });
  //     //   sortedCoorData[index]["pages"] = sortedPagesData;
  //     // });

  //     // this.setState({ data: { ...sortedCoorData[0]?.pages[0] } }); // initial page setting
  //   }

  //   if (nextProps?.coorData?.length) {
  //     this.setState({ data: { ...nextProps?.coorData[0]?.pages[0] } }); // initial page setting
  //   }

  //   if (
  //     nextProps?.pdfAndPageDetails &&
  //     Object.keys(nextProps?.pdfAndPageDetails).length !== 0 &&
  //     nextProps?.pdfAndPageDetails?.fileNo >= 0 &&
  //     nextProps?.pdfAndPageDetails?.pageNo >= 0 &&
  //     nextProps?.pdfAndPageDetails?.tagName
  //   ) {
  //     const dataToSet =
  //       this?.props?.coorData[nextProps?.pdfAndPageDetails?.fileNo]?.pages[
  //         nextProps?.pdfAndPageDetails?.pageNo
  //       ];

  //     if (
  //       this.state.selectedFile.tagName !==
  //         nextProps?.pdfAndPageDetails?.tagName ||
  //       this.state.selectedFile.fileNo !==
  //         nextProps?.pdfAndPageDetails?.fileNo ||
  //       this.state.selectedFile.pageNo !== nextProps?.pdfAndPageDetails?.pageNo
  //     ) {
  //       this.setState({ imageLoaded: false });
  //       this.checkIsImageLoadable(
  //         nextProps?.pdfAndPageDetails?.fileNo,
  //         nextProps?.pdfAndPageDetails?.pageNo
  //       )
  //         .then(() => {
  //           // Call another function after checkIsImageLoadable completes
  //           const delay = true;
  //           this.autoScrollTOCoordinate(
  //             delay,
  //             dataToSet?.width,
  //             dataToSet?.height
  //           );
  //         })
  //         .catch((error) => {
  //           console.error("Error in checkIsImageLoadable:", error);
  //         });

  //       this.setState({
  //         selectedFile: {
  //           tagName: nextProps?.pdfAndPageDetails?.tagName,
  //           fileNo: nextProps?.pdfAndPageDetails?.fileNo,
  //           pageNo: parseInt(nextProps?.pdfAndPageDetails?.pageNo),
  //         },
  //         pageRotateAngle: 0,
  //       });
  //     } else {
  //       const delay = false;
  //       this.autoScrollTOCoordinate(delay, dataToSet?.width, dataToSet?.height);
  //     }

  //     if (Object.keys(dataToSet).length !== 0) {
  //       let newAreas = [];
  //       nextProps?.pdfAndPageDetails?.coordinates?.map(
  //         (coords, indexOfCoodinates) => {
  //           const newAreaObj = {
  //             shape: "rect",
  //             coords: coords,
  //             preFillColor: "#ff00002e",
  //             fillColor: "#ff00002e",
  //           };
  //           newAreas.push(newAreaObj);
  //         }
  //       );

  //       this.setState({
  //         data: { ...dataToSet, areas: [...newAreas] },
  //         firstCoordinateToAutoScroll:
  //           nextProps?.pdfAndPageDetails?.coordinates &&
  //           nextProps?.pdfAndPageDetails?.coordinates?.length > 0
  //             ? nextProps?.pdfAndPageDetails?.coordinates[0]
  //             : null,
  //       });
  //     }
  //   }
  // }

  componentDidUpdate(prevProps) {
    const { coorData, pdfAndPageDetails } = this.props;

    // Initial setting of selected PDF file if not already set
    if (
      coorData?.length > 0 &&
      Object.values(this.state.selectedFile).every(
        (x) => x === null || x === ""
      )
      // &&
      // prevProps.coorData !== coorData
    ) {
      this.setState({
        selectedFile: {
          tagName: coorData[0]?.pdfName,
          fileNo: 0,
          pageNo: 0,
        },
        data: { ...coorData[0]?.pages[0] },
        entireCoorDataFromPageState: [...coorData],
        imageLoaded: false,
      });
      this.checkIsImageLoadable(0, 0);
    }

    // Update state when coorData changes
    if (coorData?.length > 0 && prevProps.coorData !== coorData) {
      this.setState({ data: { ...coorData[0]?.pages[0] } });
    }

    // Update when pdfAndPageDetails changes
    if (
      pdfAndPageDetails &&
      Object.keys(pdfAndPageDetails).length > 0 &&
      pdfAndPageDetails !== prevProps.pdfAndPageDetails &&
      pdfAndPageDetails.fileNo >= 0 &&
      pdfAndPageDetails.pageNo >= 0 &&
      pdfAndPageDetails.tagName
    ) {
      const dataToSet =
        coorData[pdfAndPageDetails.fileNo]?.pages[pdfAndPageDetails.pageNo];

      if (
        this.state.selectedFile.tagName !== pdfAndPageDetails.tagName ||
        this.state.selectedFile.fileNo !== pdfAndPageDetails.fileNo ||
        this.state.selectedFile.pageNo !== pdfAndPageDetails.pageNo
      ) {
        this.setState({ imageLoaded: false });

        this.checkIsImageLoadable(
          pdfAndPageDetails.fileNo,
          pdfAndPageDetails.pageNo
        )
          .then(() => {
            const delay = true;
            this.autoScrollTOCoordinate(
              delay,
              dataToSet?.width,
              dataToSet?.height
            );
          })
          .catch((error) => {
            console.error("Error in checkIsImageLoadable:", error);
          });

        this.setState({
          selectedFile: {
            tagName: pdfAndPageDetails.tagName,
            fileNo: pdfAndPageDetails.fileNo,
            pageNo: parseInt(pdfAndPageDetails.pageNo),
          },
          pageRotateAngle: 0,
        });
      } else {
        const delay = false;
        this.autoScrollTOCoordinate(delay, dataToSet?.width, dataToSet?.height);
      }

      if (Object.keys(dataToSet).length !== 0) {
        const newAreas =
          pdfAndPageDetails.coordinates?.map((coords) => ({
            shape: "rect",
            coords,
            preFillColor: "#ff00002e",
            fillColor: "#ff00002e",
          })) || [];

        this.setState({
          data: { ...dataToSet, areas: newAreas },
          firstCoordinateToAutoScroll:
            pdfAndPageDetails.coordinates?.[0] || null,
        });
      }
    }
  }

  clicked = (area, index, e) => {
    this.setState({
      selectedArea: area,
    });

    const dataToUpdate = this.state.data;
    dataToUpdate.areas[index] = {
      ...this.state.data.areas[index],
      preFillColor: "#ff00002e",
      fillColor: "#ff00002e",
    };
    this.setState({
      data: { ...dataToUpdate },
    });
  };

  checkIsImageLoadable = (fileIndex, pageNo) => {
    return new Promise((resolve, reject) => {
      if (this.props?.coorData[fileIndex]?.pages[pageNo]?.imageUrl) {
        const objImg = new Image();
        objImg.src = this.props?.coorData[fileIndex]?.pages[pageNo]?.imageUrl;
        objImg.onload = () => {
          this.setState({ imageLoaded: true });
          resolve(); // Resolve the promise when image loads successfully
        };
        objImg.onerror = () => {
          this.setState({ imageLoaded: false });
          resolve(); // Resolve the promise when image loads successfully
        };
      } else {
        this.setState({ imageLoaded: false });
        resolve(); // Resolve the promise when image loads successfully
      }
    });
  };

  fitToScreenClick = () => {
    if (this.state.prismaZoom?.current) {
      this.state.prismaZoom.current.reset();
    }
    this.setState({
      pageRotateAngle: 0,
      imageMapperWidth: this?.state?.originalMapperWidth,
      imageMapperHeight: this?.state?.originalMapperHeight,
    });
  };

  rotateClick = (value) => {
    if (value === "right") {
      this.setState({ pageRotateAngle: this.state.pageRotateAngle + 90 });
    }
    if (value === "left") {
      this.setState({ pageRotateAngle: this.state.pageRotateAngle - 90 });
    }
  };

  onZoomChange = (zoom) => {
    this.setState({
      zoom: zoom,
    });
  };

  onClickZoom = (value) => {
    if (value === "out") {
      if (this.state.prismaZoom?.current) {
        this.state.prismaZoom.current.zoomOut(1);
      }
    } else {
      if (this.state.prismaZoom?.current) {
        this.state.prismaZoom.current.zoomIn(1);
      }
    }
  };

  searchPageClick = (value) => {
    if (
      value <
        this.props?.coorData[this.state.selectedFile?.fileNo].pages.length &&
      value >= 0
    ) {
      this.setState({
        selectedFile: {
          ...this.state.selectedFile,
          pageNo: Number(value),
        },
        pageRotateAngle: 0,
        data: this.props?.coorData[this.state?.selectedFile?.fileNo]?.pages[
          Number(value)
        ],
        imageMapperWidth: this?.state?.originalMapperWidth,
        imageMapperHeight: this?.state?.originalMapperHeight,
      });

      if (this.state.prismaZoom?.current) {
        this.state.prismaZoom.current.reset();
      }
      this.setState({ imageLoaded: false });
      this.checkIsImageLoadable(this.state.selectedFile.fileNo, Number(value));
    }
  };

  handlePageChange = (value) => {
    if (value === "prev" && parseInt(this.state.selectedFile?.pageNo) !== 0) {
      const prevPageNo = parseInt(this.state.selectedFile?.pageNo) - 1;
      this.setState({
        selectedFile: {
          ...this.state.selectedFile,
          pageNo: prevPageNo,
        },
        pageRotateAngle: 0,
        data: this.props?.coorData[this.state?.selectedFile?.fileNo]?.pages[
          prevPageNo
        ],
      });

      if (this.state.prismaZoom?.current) {
        this.state.prismaZoom.current.reset();
      }
      this.setState({ imageLoaded: false });
      this.checkIsImageLoadable(this.state.selectedFile.fileNo, prevPageNo);
    } else if (value === "next") {
      const nextPageNo = parseInt(this.state.selectedFile?.pageNo) + 1;

      this.setState({
        selectedFile: {
          ...this.state.selectedFile,
          pageNo: nextPageNo,
        },
        pageRotateAngle: 0,
        data: this.props?.coorData[this.state?.selectedFile?.fileNo]?.pages[
          nextPageNo
        ],
      });
      if (this.state.prismaZoom?.current) {
        this.state.prismaZoom.current.reset();
      }
      this.setState({ imageLoaded: false });
      this.checkIsImageLoadable(this.state.selectedFile.fileNo, nextPageNo);
    }
    this.setState({
      imageMapperWidth: this?.state?.originalMapperWidth,
      imageMapperHeight: this?.state?.originalMapperHeight,
    });
  };

  handleFileChange(tagName, index) {
    this.setState({
      selectedFile: {
        tagName: tagName,
        fileNo: index,
        pageNo: 0,
      },
      pageRotateAngle: 0,
      data: this?.props?.coorData[index]?.pages[0],
      imageMapperWidth: this?.state?.originalMapperWidth,
      imageMapperHeight: this?.state?.originalMapperHeight,
    });

    if (this.state.prismaZoom?.current) {
      this.state.prismaZoom.current.reset();
    }
    this.setState({ imageLoaded: false });
    this.checkIsImageLoadable(index, 0);
  }

  onClickCellToRedirect = (tagName, pageNo, fileNo) => {
    if (tagName && !isNaN(pageNo) && !isNaN(fileNo)) {
      this.setState({
        selectedFile: {
          tagName: tagName,
          fileNo: fileNo,
          pageNo: pageNo,
        },
        pageRotateAngle: 0,
        data: this?.props?.coorData[fileNo]?.pages[pageNo],
      });
    }

    if (this.state.prismaZoom?.current) {
      this.state.prismaZoom.current.reset();
    }
    this.setState({ imageLoaded: false });
    this.checkIsImageLoadable(fileNo, 0);
  };

  onClickChangeOrientation = () => {
    this.setState({
      imageMapperWidth: this?.state?.imageMapperHeight,
      imageMapperHeight: this?.state?.imageMapperWidth,
    });
  };
  // handleImageLoad = () => {
  //   this.setState({ imageLoadedInDiv: true });
  // };

  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.searchPageClick(this.state.inputValue - 1);
    }
  };

  autoScrollTOCoordinate = (delay, resolutionWidth, resolutionHeight) => {
    resolutionWidth &&
      resolutionHeight &&
      setTimeout(
        () => {
          // Original and resized image dimensions
          const originalWidth = resolutionWidth;
          const originalHeight = resolutionHeight;
          const resizedWidth = this?.state?.imageMapperWidth;
          const resizedHeight = this?.state?.imageMapperHeight;

          // Calculate scaling factors
          const widthScalingFactor = resizedWidth / originalWidth;
          const heightScalingFactor = resizedHeight / originalHeight;

          // Get coordinates from state
          const coordinates = this.state?.firstCoordinateToAutoScroll;

          // Apply scaling to coordinates if they exist
          const scaledX = coordinates ? coordinates[0] * widthScalingFactor : 0;
          const scaledY = coordinates
            ? coordinates[1] * heightScalingFactor
            : 0;

          // Adjust for scrolling 100 is just gap from top and left
          const scrollTop = scaledY > 50 ? scaledY - 50 : 0;
          const scrollLeft = scaledX > 50 ? scaledX - 50 : 0;

          // Perform the scrolling
          // document.getElementById("ImageIdAutoScroll").scrollTo({
          //   top: scrollTop,
          //   left: scrollLeft,
          //   behavior: "smooth",
          // });

          const element = document.getElementById("ImageIdAutoScroll");
          if (element) {
            element.scrollTo({
              top: scrollTop,
              left: scrollLeft,
              behavior: "smooth",
            });
          } else {
            console.error("Element with ID 'ImageIdAutoScroll' not found.");
          }
        },
        delay ? 1000 : 0
      );
  };

  render() {
    return (
      // <Box className={this?.props?.isFullView ? "container-2" : "container-1"}>

      <Box className={"container-1"}>
        <Grid className="imageview-header">
          <Grid item xs={8}>
            <div className="ac-processor-pdf-slider-body">
              <section>
                <div>
                  <Carousel
                    ssr
                    // partialVisible
                    deviceType={this.props.deviceType}
                    itemClass="image-item"
                    responsive={this.state.responsive}
                    customRightArrow={<CustomRightArrow />}
                    customLeftArrow={<CustomLeftArrow />}
                  >
                    {this.props?.coorData?.map((file, index) => {
                      const label = file.pdfName;
                      const truncatedLabel =
                        label.length > 6 ? label.slice(0, 6) + "..." : label;
                      const tooltipLabel = label.length > 6 ? label : "";
                      return (
                        <div
                          className="ac-processor-slider-content"
                          onClick={() =>
                            this.handleFileChange(file.pdfName, index)
                          }
                        >
                          <PdfICon
                            fillColor={
                              this.state.selectedFile?.fileNo === index
                                ? "#E52222"
                                : "#5d5d5d"
                            }
                            // height={
                            //   this.state.selectedFile?.fileNo === index
                            //     ? "25px"
                            //     : "25px"
                            // }
                            // width={
                            //   this.state.selectedFile?.fileNo === index
                            //     ? "25px"
                            //     : "25px"
                            // }
                          />

                          <Tooltip title={tooltipLabel}>
                            <Typography
                              sx={{ marginLeft: "4px" }}
                              variant="caption"
                              display="block"
                            >
                              {truncatedLabel}
                            </Typography>
                          </Tooltip>
                        </div>
                      );
                    })}
                  </Carousel>
                </div>
              </section>
            </div>
          </Grid>
          <Grid item xs={4} className="angle-arrow-grid" spacing={1}>
            <div>
              <FormControl
                className="img-number"
                variant="standard"
                size="small"
              >
                <Input
                  size="small"
                  type="number"
                  id="standard-adornment-password"
                  onKeyDown={this.handleKeyDown} // Add the event listener here
                  onChange={(e) =>
                    this.setState({ inputValue: e.target.value })
                  }
                  className="p-0"
                  placeholder="Page"
                  endAdornment={
                    <InputAdornment
                      position="end"
                      className="password-conatiner"
                      size="small"
                    >
                      <IconButton
                        className="password-icon-btn"
                        aria-label="toggle password visibility"
                        onClick={() =>
                          this.searchPageClick(this.state.inputValue - 1)
                        }
                        size="small"
                      >
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  }
                />
              </FormControl>
            </div>

            <div>
              <div className="angle-arrow-display">
                <IconButton
                  className={
                    parseInt(this.state.selectedFile?.pageNo) + 1 <= 1
                      ? "arrow-angle-condition"
                      : "arrow-angle-condition2"
                  }
                  onClick={(e) =>
                    parseInt(this.state.selectedFile?.pageNo) !== 0 &&
                    this?.handlePageChange("prev")
                  }
                >
                  <img
                    className="angle-arrow-left"
                    src={AngleArrowLeft}
                    alt="prev page"
                  />
                </IconButton>

                <IconButton
                  className={
                    parseInt(this.state.selectedFile?.pageNo) + 1 >=
                    this.props?.coorData[this.state.selectedFile?.fileNo]?.pages
                      ?.length
                      ? "arrow-angle-condition"
                      : "arrow-angle-condition2"
                  }
                  onClick={(e) =>
                    parseInt(this.state.selectedFile?.pageNo) + 1 !==
                      this.props?.coorData[this.state.selectedFile?.fileNo]
                        ?.pages?.length && this?.handlePageChange("next")
                  }
                >
                  <img
                    className="angle-arrow-right"
                    src={AngleArrowRight}
                    alt="next page"
                  />
                </IconButton>
              </div>

              <>
                <h1 className="angle-arrow-text">{`Page ${
                  parseInt(this.state.selectedFile?.pageNo) + 1
                }/ ${
                  this.props?.coorData[this.state.selectedFile?.fileNo]?.pages
                    ?.length
                }`}</h1>
              </>
            </div>

            <MapToolBar
              file={this.props?.coorData[this.state.selectedFile?.fileNo]}
              handlePageChange={this.handlePageChange}
              selectedFile={this.state.selectedFile}
              searchPageClick={this.searchPageClick}
              onClickZoom={this.onClickZoom}
              zoom={this.state.zoom}
              rotateClick={this.rotateClick}
              fitToScreenClick={this.fitToScreenClick}
              onClickChangeOrientation={this.onClickChangeOrientation}
            />
          </Grid>
        </Grid>
        <Grid className="view_pdf_new" md={12} id="ImageIdAutoScroll">
          {this.state?.imageLoaded ? (
            <div
              id="container"
              style={{
                transform: `rotate(${this.state.pageRotateAngle}deg)`,
                transition: "transform 150ms ease", // smooth transition
                cursor: "pointer",
                left: [
                  90, 270, 450, 630, 810, 990, 1170, 1350, 1530, 1710, 1890,
                ].includes(this.state.pageRotateAngle)
                  ? "14%"
                  : 0,
                position: "relative",
              }}
            >
              <PrismaZoom
                minZoom={1}
                maxZoom={10}
                animDuration={0.5}
                allowZoom={this.state.allowZoom}
                ref={this.state.prismaZoom}
                onZoomChange={this.onZoomChange}
              >
                {/* {this.state?.imageLoaded ? ( */}
                <>
                  {/* <img
                    alt="Map_Image"
                    src={this.state?.data?.imageUrl}
                    onLoad={this.handleImageLoad}
                    className="d-none"
                  /> */}
                  {/* {this.state.imageLoadedInDiv ? ( // this logoc is added due to very initial time bounding box is not appearing */}
                  {/* // <LazyLoad height={200} offset={100}> */}
                  <ImageMapper
                    src={this.state?.data?.imageUrl}
                    map={this.state?.data}
                    width={this?.state?.imageMapperWidth}
                    height={this?.state?.imageMapperHeight}
                    onClick={(area, index, e) => this.clicked(area, index, e)}
                    imgWidth={this?.state?.imageMapperWidth}
                    natural={true}
                    responsive={true}
                    parentWidth={this?.state?.imageMapperWidth}
                    active={this.props.role === "validator" ? false : true}
                    disabled={this.props.role === "validator" ? true : false}
                  />
                  {/* ) : (
                    // </LazyLoad>
                    <Box className="premap-loader-container">
                      <CircularProgress />
                      <span className="premap-loader-style">
                        Loading 222...
                      </span>
                    </Box>
                  )}{" "} */}
                </>
                {/* ) : (
                <Box className="imageView-progressbar-div">
                <CircularProgress color="primary" size={40} thickness={4} />
                <Label
                  text=" Loading..."
                  fontSize="16px"
                  paddingLeft="20px"
                ></Label>
              </Box>
               )} */}
              </PrismaZoom>
            </div>
          ) : (
            <Box className="imageView-progressbar-div">
              <CircularProgress color="primary" size={40} thickness={4} />
              <Label
                text=" Loading..."
                fontSize="16px"
                paddingLeft="20px"
              ></Label>
            </Box>
          )}
        </Grid>
      </Box>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    acts: bindActionCreators(acts, dispatch),
  };
};

function mapStateToProps(state) {
  return {
    coorData: state.vali?.coorData?.coordinatesDetails || [],
    apiStatus: state.vali?.apiStatus,
    pdfAndPageDetails: state.vali?.pdfAndPageDetails,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageViewer);
